import { render, staticRenderFns } from "./ExportAddPagesTab.vue?vue&type=template&id=58ef4866"
import script from "./ExportAddPagesTab.vue?vue&type=script&lang=js"
export * from "./ExportAddPagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ef4866')) {
      api.createRecord('58ef4866', component.options)
    } else {
      api.reload('58ef4866', component.options)
    }
    module.hot.accept("./ExportAddPagesTab.vue?vue&type=template&id=58ef4866", function () {
      api.rerender('58ef4866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/ExportAddPagesTab.vue"
export default component.exports